export default {
  title: {
    employeeManagement: 'Employee Management'
  },
  menu: 'Employee Management',
  label: {
    name: 'Name',
    validationInfo: 'Validation Info',
    email: 'Email Address',
    updateTime: 'Update Time',
    checkAll: 'All',
    pending: 'Pending',
    approve: 'Approve',
    reject: 'Reject',
    resign: 'Resign',
    approved: 'Approved',
    rejected: 'Rejected',
    resigned: 'Resigned',
    unregistered: 'Pending register',
    statusAll: 'All',
    registerCheck: 'Enable Employee Verification',
    setupEmailDomain: 'Setup Email Domain',
    updateEmployeeStatus: 'Batch Update Employee Status',
    emailDomain: 'Email Domain: ',
    pinCode: 'Company Pin Code: {companyPinCode}',
    basicInfoTitle: 'Basic Information',
    allTotal: 'Total Employee: {allTotal}',
    downloadEmployee: 'Download all employee',
    uploadEmployee: 'EXCEL File:',
    emailSuffixTitle: 'Input company email domain, seperate with "|" if has more than one.',
    emailSuffixContent: 'E.g. If your company email is abc@def.com, the company email domain is def.com',
    employeeStatusTip: 'Confirm you want to change employee status to "{status}"?',
    companyName: 'Company Name',
    operation: 'Operation',
    rows: 'rows {row}: ',
    batchUploadResult: 'Result',
    uploadCount: 'Total uploaded: {total}',
    updateCount: 'Total updated: {total}',
    waitRegisterCount: '# of pending register employee: {total}',
    failCount: 'Failed: {total}',
    detail: 'Detail',
    invalidStatus: 'Invalid status: {info}',
    notFound: 'No employee has an email address: {info}',
    hasUsed: 'This employee ID has been registered as another account: {info}',
    noRegister: 'Not enable employee verification: {info}',
    noEmail: 'No email, register failed: {info}',
    duplicateEmail: 'Email has existed in file: {info}'
  },
  placeholder: {
    search: 'Search (Email/Validation Info/Name)'
  },
  btn: {
    approve: 'Approve',
    reject: 'Reject',
    resign: 'Resign',
    pending: 'Pending',
    upload: 'Browse'
  },
  message: {
    uploadTip: 'You can only upload a excel file',
    uploadError: 'Upload failed, please upload again',
    optionSuccess: 'Option Success',
    optionField: 'Option Field',
    uploadType: 'Please only use .xls .xlsx files',
    emailSuffixValidate: "Invalid character, only can input letter, number, '.', '-' and '|'."
  }
}
